import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import App from "../App";
import RegisterPage from "../pages/start/register-page";
import LoginPage from "../pages/start/login-page";
import PrivateRoute from "./privateRoute";
import Dashboard from "../components/dashboard/dashboard";
import { ProfilePage } from "../pages/profile/profile";
import LandingPage from "../pages/landing/landing";
import PricingPage from "../pages/pricing/pricing-page";
import ContactPage from "../pages/contact/contact-page";
import OpinionesPage from "../pages/opiniones/opiniones-page";
import CursosPage from "../pages/cursos/cursos-page";
import PrimariaPage from "../pages/cursos/primaria-page";
import EsoBachillerPage from "../pages/cursos/esoBachiller-page";
import AdultosPage from "../pages/cursos/adultos-page";
import IntensivoPage from "../pages/cursos/intensivo-page";



export const PageRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path={"/"} element={<LandingPage />} />
        <Route path={"/pricing"} element={<PricingPage />} />
        <Route path={"/contact"} element={<ContactPage />} />
        <Route path={"/opiniones"} element={<OpinionesPage />} />
        <Route path={"/cursos"} element={<CursosPage />} />
        <Route path={"/cursos/primaria"} element={<PrimariaPage />} />
        <Route path={"/cursos/eso_bachiller"} element={<EsoBachillerPage />} />
        <Route path={"/cursos/adultos"} element={<AdultosPage />} />
        <Route path={"/cursos/intensivo"} element={<IntensivoPage />} />
        <Route path={"/newRouteHidden"} element={<App />} />
        <Route path={"private"} element={<PrivateRoute />}>
          <Route path={"dashboard"} element={<Dashboard />} />
          <Route path={"profile"} element={<ProfilePage />} />
        </Route>
      </Routes>
    </Router>
  );
};
